<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="template-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="80%"
            :addButton="{ enabled: true, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingEditTemplate="loadingEditTemplate"
        >
            <slot slot="filter">
                <el-col :md="6" :xl="4" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <cus-dialog
            ref="form-saveas1"
            :overflow="false"
            :footerVisible="true"
            :okVisible="false"
            :title="currentItem.title"
            :visible.sync="currentItem.visibleSync"
            :close-on-click-modal="false"
            width="70%"
        >
            <cus-form ref="form1" :columns="formColumns" :data="currentItem.data"></cus-form>
            <el-row>
                <el-col class="padding-left20" :span="24">
                    <label for="items" class="el-form-item__label"><span class="item-label">项 目</span></label>
                    <div class="el-form-item__content align-left"></div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="align-right">
                    <ListView :columns="tableColumns" :datalist="currentItem.data.items" :tableHeight="dialogHeight"></ListView>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="currentItem.visibleSync = false">确 定</el-button>
            </div>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnalgesicTemplate`,
    props: {},
    created() {
        this.loadDrug()
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
    },
    data() {
        return {
            title: `镇痛配方模板`,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            hiddenConfirm: true,
            currentItem: {
                visibleSync: false,
                title: `查看`,
                data: {}
            },
            url: {
                baseURL: `api/AcisSystem/AnalgesicTemplate`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            },
            item_configs: [],
            drug_section: {}
        }
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `currentUser`, `active_ward`, `drug/drug_unit`, `sys_enums`, `screenHeight`, `section_auth`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        dialogHeight() {
            return this.screenHeight && (this.screenHeight - 290) || 0
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        formColumns() {
            return [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isEditable: true,
                    readonly: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isEditable: true,
                    readonly: true,
                    colspan: 6,
                    options: `enum_region_type`
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isEditable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: true
                }]
        },
        tableColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                },
                {
                    type: `remoteselect`,
                    prop: `dic_drug_item`,
                    label: `药品`,
                    isReadTable: true,
                    // width: "400",
                    isListable: true,
                    readonly: true
                },
                {
                    type: `number`,
                    prop: `dosage`,
                    label: `剂量`,
                    isListable: true,
                    width: 200,
                    readonly: true
                },
                {
                    type: `select`,
                    prop: `dic_unit_id`,
                    label: `单位`,
                    isReadTable: true,
                    isListable: true,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: false }).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    }),
                    readonly: true
                }
            ]
        },
        columnList() {
            let username = (this.currentUser && this.currentUser.username) || `--`
            var edittmp = this.isHavePermissions(`all`) || this.isHavePermissions(`edit`)
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    options: `enum_region_type`,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        } else {
                            row.dic_ward_ids = null
                        }
                    }
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return (row.region_type === 1)
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    width: `140`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `120`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if (username == row.owner && row.region_type == 1 || edittmp) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateView`,
                                    permission: `default`
                                },
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `DeleteData`,
                                    permission: `default`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `查看`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadingEditTemplate`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `items`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    readonly: false,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `remoteselect`,
                            prop: `dic_drug_item`,
                            label: `药品`,
                            isReadTable: true,
                            // width: "400",
                            isListable: true,
                            readonly: false,
                            options: (that, { row }) => {
                                return q => {
                                    return this.myaxios.get(`/api/AcisSystem/Drug/SearchAnalgesics`, q)
                                }
                            },
                            change: (that, { row, area }) => {
                                let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug_item.value}`)
                                req.then(data => {
                                    this.$set(row, `dic_unit_id`, data && data.dic_unit_id)
                                    let thisdose = 0
                                    if (data && data.UseDose != null && data.UseDose != 0) {
                                        thisdose = data.UseDose
                                    } else {
                                        thisdose = data.dose
                                    }
                                    this.$set(row, `dosage`, thisdose)
                                })
                            }
                        },
                        {
                            type: `number`,
                            prop: `dosage`,
                            label: `剂量`,
                            width: 100,
                            isReadTable: true,
                            isListable: true,
                            readonly: false
                        },
                        {
                            type: `select`,
                            prop: `dic_unit_id`,
                            label: `单位`,
                            isReadTable: true,
                            isListable: true,
                            options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: false }).map(d => {
                                return {
                                    label: `${d.label}`,
                                    value: d.value,
                                    disabled: d.disabled
                                }
                            }),
                            readonly: false
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 300
                    }
                }
            ]
        }
    },
    methods: {
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `analgesic_temp_area:${permiskey}`) != -1
        },
        loadingEditTemplate({ row }) {
            this.loadOne(row)
                .then(data => {
                    let r = { ...data }
                    this.currentItem.visibleSync = true
                    r.title = `查看`
                    this.currentItem.data = r
                    console.log(`查看查看`)
                    console.log(this.currentItem.data)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadTemplates(resolve, reject) {
            let that = this

            let req1 = that.myaxios.get(`api/AcisSystem/AnalgesicTemplate/Get`)
            req1.then((data) => {
                data = _.filter(data, d => {
                    if (this.isHavePermissions(`all`) || this.isHavePermissions(`edit`) || this.isHavePermissions(`read`)) {
                        let allRegionValue = []
                        _.map(that.ward_auth, d => {
                            allRegionValue.push(d.value)
                        })
                        let owids = (d.dic_operating_ward_id && d.dic_operating_ward_id != `` && d.dic_operating_ward_id.split(`,`)) || []
                        let hasow =
                                _.filter(owids, c => {
                                    return _.includes(allRegionValue, `ow_${c}`)
                                }) || []
                        let rwids = (d.dic_recovery_ward_id && d.dic_recovery_ward_id != `` && d.dic_recovery_ward_id.split(`,`)) || []
                        let hasrw =
                                _.filter(rwids, c => {
                                    return _.includes(allRegionValue, `rw_${c}`)
                                }) || []
                        if (this.isHavePermissions(`all`)) {
                            return (d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)) ||
                            (d.region_type == 1)
                        }

                        if (this.isHavePermissions(`edit`) || this.isHavePermissions(`read`)) {
                            return (d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)) ||
                            (d.region_type == 1 && d.owner == this.currentUser.username)
                        }
                    } else {
                        return d.region_type == 1 && d.owner == this.currentUser.username
                    }
                })

                _.map(data, d => {
                    let owards = d.dic_operating_ward_id && _.split(d.dic_operating_ward_id, `,`).map(p => {
                        p = `ow_${p}`
                        return p
                    }) || []
                    let rwards = d.dic_recovery_ward_id && _.split(d.dic_recovery_ward_id, `,`).map(p => {
                        p = `rw_${p}`
                        return p
                    }) || []
                    let wards = owards.concat(rwards)
                    d.dic_ward_ids = wards
                })
                if (that.dic_ward_id) {
                    data = _.filter(data, r => {
                        return _.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1
                    })
                }
                resolve(data)
            })
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`api/AcisSystem/AnalgesicTemplate/Get/${row.id}`)
                req.then(data => {
                    let dd = { ...row }
                    dd.items = _.filter(data.items, x => x.dic_drug && x.dic_drug.disabled == false).map(d => {
                        let r = { ...d.items }
                        Object.assign(r, {
                            id: d.id,
                            dic_drug_item: this.getDrugItem(d.dic_drug_id),
                            dic_drug_id: d.dic_drug_id,
                            dosage: d.dosage,
                            dic_unit_id: d.dic_unit_id
                        })
                        return r
                    }) || []
                    resolve(dd)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, tp) {
            return new Promise((resolve, reject) => {
                if (row.region_type == 2 && (!row.dic_ward_ids || row.dic_ward_ids == ``)) {
                    this.$message.error(`请选择可用区域！`)
                    return
                }
                var details = _.filter(row.items, d => d.dic_drug_item && d.dic_drug_item.value > 0)
                if (details.length == 0) {
                    this.$message.error(`请选择药品！`)
                    return
                }
                try {
                    details.forEach(d => {
                        if (!d.dosage) {
                            this.$message.error(`请录入药品剂量！`)
                            throw new Error(`EndIterative`)
                        }
                        if (!d.dic_unit_id || d.dic_unit_id == ``) {
                            this.$message.error(`请选择药品单位！`)
                            throw new Error(`EndIterative`)
                        }
                    })
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    return
                }

                let owItems = _.filter(row.dic_ward_ids, d => _.startsWith(d, `ow_`)).map(d => {
                    d = d.substr(3)
                    return d
                })
                let rwItems = _.filter(row.dic_ward_ids, d => _.startsWith(d, `rw_`)).map(d => {
                    d = d.substr(3)
                    return d
                })

                let req = this.myaxios[tp](`api/AcisSystem/AnalgesicTemplate/${tp}`, {
                    id: row.id,
                    name: row.name,
                    region_type: row.region_type,
                    dic_operating_ward_id: row.region_type == 1 ? `` : _.join(owItems, `,`),
                    dic_recovery_ward_id: row.region_type == 1 ? `` : _.join(rwItems, `,`),
                    items: _.reduce(
                        _.groupBy(
                            _.filter(row.items, d => d.dic_drug_item && d.dic_drug_item.value),
                            `dic_drug_item.value`
                        ),
                        function(result, value, key) {
                            let sOne =
                                _.find(value, d => {
                                    return d.id > 0
                                }) || value[0]
                            let r = {
                                id: sOne.id,
                                sys_analgesic_template_id: row.id,
                                dic_drug_id: key,
                                dosage: sOne.dosage,
                                dic_unit_id: sOne.dic_unit_id
                            }
                            result.push(r)
                            return result
                        },
                        []
                    )
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        },
        loadDrug() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/Drug/Search`)
                    .then(data => {
                        this.dic_drug_items = data
                        resolve(this.dic_drug_items)
                    })
            })
        },
        getDrugItem(id) {
            let item = _.find(this.dic_drug_items, x => x.value == id)
            return item
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Analgesic/Template.vue